

document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".feather-reveal");
  if (!items.length) return;

  items.forEach(el => el.classList.remove("is-visible"));

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        requestAnimationFrame(() => e.target.classList.add("is-visible"));
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });

  items.forEach((el) => io.observe(el));
});
